"use client";
import { useAuthBaseURL } from "@/hooks/useAuthBaseURL";
import { useTranslations } from "next-intl";

const LoginLink = () => {
  const authBaseUrl = useAuthBaseURL();
  const t = useTranslations("ErrorPages");

  return (
    <a
      className="text-primary hover:text-primary underline"
      href={new URL("login", authBaseUrl).toString()}
    >
      {t("createAccount")}
    </a>
  );
};
export default LoginLink;
